<template>
	<div class="full" id="summaryStatisticsChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {
			date: {
				default: () => {
					return ''
				}
			},
			kpi: {
				default: () => {
					return []
				}
			},
			formData: {
				default: () => {
					return null
				}
			},
			sourceData: {
				type: Array,
				default: () => {
					return []
				}
			},
			tableData: {
				type: Array,
				default: () => {
					return []
				}
			},
			chartData: {
				type: Array,
				default: () => {
					return []
				}
			},
			staticStaff: {
				type: Array,
				default: () => {
					return []
				}
			},
			chartField: {
				default: () => {
					return 'realPayAmt1d'
				}
			},
			chartTitle: {
				default: () => {
					return '净销售额'
				}
			},
			childrenRow: {
				default: () => {
					return null
				}
			},



		},
		data() {
			return {
				chart: null,
				singleField: ['fstReplyDur1d', 'avgReplyDur1d', 'conversionrate']

			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.statisticsChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				this.statisticsChart()
			},
			statisticsChart() {
				let series = []
				let tableData = []
				let legendData = []
				tableData = JSON.parse(JSON.stringify(this.tableData))
				tableData.forEach((item) => {
					item.departmentid = this.$systemMethods.getdepartment(item.departmentid)
				})
				let xarr = []
				if (this.staticStaff.length == 0) {
					tableData = this.$Lodash.orderBy(tableData, item => parseInt(item[this.chartField]), ['desc'])
					console.log(tableData)
					xarr = tableData.map((item) => {
						return item[item.xfield]
					})

					series.push({
						name: this.chartTitle,
						type: 'bar',
						label: {
							show: true,
							position: 'top'
						},
						emphasis: {
							focus: 'series'
						},
						data: tableData.map((item) => {
							return item[this.chartField]
						})
					})

					let kpidata = []
					let kpi = this.kpi
					let kpigroupedData = this.$Lodash.groupBy(this.kpi, tableData[0].xfield)
					//console.log(kpigroupedData,1111)
					kpi = []
					for (let i in kpigroupedData) {
						kpi.push({
							departmentid: this.$systemMethods.getdepartment(kpigroupedData[i][0].departmentid),
							psnNickName: kpigroupedData[i][0].psnNickName,
							target: this.$Lodash.sumBy(kpigroupedData[i], item => parseFloat(item.target))
						})
					}
					//console.log(xarr,kpi)
					xarr.forEach((item) => {
						let kpiitem = kpi.find((_item) => {
							return _item[tableData[0].xfield] == item
						})
						if (kpiitem) {
							kpidata.push(kpiitem.target)
						} else {
							kpidata.push(0)
						}
					})

					if (this.chartField == 'realPayAmt1d') {
						series.push({
							name: '净销售额目标',
							type: 'line',
							//step: 'middle',
							smooth: true,
							lineStyle: {
								color: '#E6A23C'
							},
							// label: {
							// 	show: true,
							// 	position: 'top'
							// },
							emphasis: {
								focus: 'series'
							},
							data: kpidata
						})
					}

				} else {
					tableData = this.$Lodash.orderBy(tableData, item => new Date(item.dateId), ['asc'])
					xarr = this.$Lodash.map(tableData,'dateId')
					xarr = [...new Set(xarr)]
					let Yarr = this.$Lodash.groupBy(tableData, 'psnNickName')
					legendData = Object.keys(Yarr)
					for (let i in Yarr) {						
						let data = xarr.map((xitem)=>{
							let yitem = Yarr[i].find((yitem)=>{
								return yitem.dateId == xitem
							})
							if(yitem){
								return yitem[this.chartField]
							}else{
								return 0
							}
						})

						series.push({
							name: i,
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							},
							emphasis: {
								focus: 'series'
							},
							data: data
						})
					}
				}
				

				//console.log(tableData,123)

				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('summaryStatisticsChart'))
				}
				this.chart.setOption({
					title: {
						text: this.chartTitle,
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: legendData
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
					},
					yAxis: {},
					series: series
				})


				//console.log(xarr,this.tableData)

			},
			groupBySum(array, groupKey, sumKey) {
				//console.log(array, groupKey, sumKey)
				return array.reduce((accumulator, item) => {
					let group = accumulator.find(i => i[groupKey] === item[groupKey]);
					if (group) {
						group[sumKey] += item[sumKey] ? parseFloat(item[sumKey]) : 0;
					} else {
						let newGroup = {};
						newGroup[groupKey] = item[groupKey];
						newGroup[sumKey] = parseFloat(item[sumKey]);
						accumulator.push(newGroup);
					}

					return accumulator;
				}, []);
			}
		},
		components: {

		}
	}
</script>